<mat-dialog-content>
    <div class="close" [style.top]="closeTop" [style.right]="closeRight">
        <mat-icon (click)="close()">close</mat-icon>
    </div>
    <iframe [src]="url"></iframe>
</mat-dialog-content>
